import { useEffect, useState } from "react";
import { toast } from "sonner";
import { MailCheck } from "lucide-react";
import { api, formatApiError } from "../../lib/api";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";

export const AccountOtpStep = ({ req, r, onDone, onCancel }) => {
  const [code, setCode] = useState("");
  const [busy, setBusy] = useState(false);
  const [wait, setWait] = useState(60);
  useEffect(() => {
    if (wait <= 0) return undefined;
    const t = setTimeout(() => setWait((w) => w - 1), 1000);
    return () => clearTimeout(t);
  }, [wait]);

  const verify = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post(`/profit/account-changes/${req.requestId}/verify`, { code });
      toast.success("Kode benar. Perubahan rekening dikirim ke PT SJI untuk dikonfirmasi.");
      onDone();
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };
  const resend = async () => {
    try {
      await api.post(`/profit/account-changes/${req.requestId}/resend`);
      toast.success("Kode baru telah dikirim");
      setWait(60);
    } catch (err) {
      toast.error(formatApiError(err));
    }
  };

  return (
    <form onSubmit={verify} className="space-y-2 mt-3" data-testid={`account-otp-form-${r}`}>
      <p className="flex gap-2 text-xs text-emerald-900 bg-emerald-50 border border-emerald-200 rounded-md p-2" data-testid={`account-otp-info-${r}`}>
        <MailCheck className="h-4 w-4 shrink-0" /> Kode 6 angka dikirim ke {req.email}, berlaku {req.expiresInMinutes} menit. Rekening baru belum aktif: setelah kode benar, pembayaran ke penerima ini ditahan sampai PT SJI mengonfirmasi rekening baru.
      </p>
      <Input required inputMode="numeric" maxLength={6} placeholder="Kode 6 angka" value={code} autoComplete="one-time-code"
        onChange={(e) => setCode(e.target.value.replace(/\D/g, ""))} className="tracking-[0.4em] font-semibold" data-testid={`account-otp-input-${r}`} />
      <Button disabled={busy || code.length !== 6} className="w-full bg-emerald-800 hover:bg-emerald-900" data-testid={`account-otp-submit-${r}`}>Verifikasi & Kirim ke PT SJI</Button>
      <div className="flex justify-between text-xs font-semibold">
        <button type="button" onClick={onCancel} className="text-slate-600" data-testid={`account-otp-cancel-${r}`}>Batal</button>
        <button type="button" disabled={wait > 0} onClick={resend} className="text-emerald-800 disabled:text-slate-400" data-testid={`account-otp-resend-${r}`}>
          {wait > 0 ? `Kirim ulang (${wait} dtk)` : "Kirim ulang kode"}
        </button>
      </div>
    </form>
  );
};
